import React, { useState } from "react";
import { Button, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import EditPhotosButton from "./EditPhotosButton";

const EditSubCategoryButton = ({
  subCategory,
  updateStories,
  deleteStories,
  categoryId,
  categoryTitle,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    hideModal();
    await updateStories({
      id: subCategory.id,
      payload: { abroad_procedure: { ...data } },
    });
  };
  const renderContent = () => {
    return (
      <div style={{ paddingTop: 12, paddingBottom: 30 }}>
        This action will delete the Remove Stories({subCategory.title})
        permanently. Are you sure?
      </div>
    );
  };

  const confirmDelete = () => {
    Modal.confirm({
      title: `Remove Stories`,
      icon: "",
      content: renderContent(),
      closable: true,
      okText: `REMOVE`,
      onOk() {
        deleteStories({ id: subCategory.id });
        hideModal();
      },
      cancelButtonProps: { style: { display: "none" } },
    });
  };
  const footer = (
    <Button icon={<DeleteOutlined />} onClick={confirmDelete} danger>
      Delete
    </Button>
  );

  return (
    <EditPhotosButton
      story={subCategory && subCategory}
      surgery_id={categoryId}
    />
  );
};
export default EditSubCategoryButton;
